import React from 'react';
import { Loader } from 'lucide-react';

interface LoadingProgressBarProps {
  message?: string;
  progress?: number; // 0-100
  showProgress?: boolean;
}

export const LoadingProgressBar: React.FC<LoadingProgressBarProps> = ({ 
  message = 'Analyzing...', 
  progress,
  showProgress = true 
}) => {
  return (
    <div className="w-full max-w-2xl mx-auto bg-slate-900/80 backdrop-blur-sm border border-indigo-500/30 rounded-xl p-6 shadow-2xl">
      <div className="flex items-center gap-4 mb-4">
        <div className="relative">
          <Loader className="w-8 h-8 text-indigo-400 animate-spin" />
          <div className="absolute inset-0 w-8 h-8 border-2 border-indigo-400/20 rounded-full animate-ping"></div>
        </div>
        <div className="flex-1">
          <p className="text-white font-semibold text-lg">{message}</p>
          {showProgress && progress !== undefined && (
            <p className="text-slate-400 text-sm mt-1">
              {progress < 100 ? `Processing... ${Math.round(progress)}%` : 'Finalizing...'}
            </p>
          )}
        </div>
      </div>
      
      {showProgress && (
        <div className="w-full bg-slate-800 rounded-full h-2.5 overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-full transition-all duration-300 ease-out relative overflow-hidden"
            style={{ width: `${progress || 0}%` }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
          </div>
        </div>
      )}
      
      {!showProgress && (
        <div className="w-full bg-slate-800 rounded-full h-2.5 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-full animate-pulse relative overflow-hidden" style={{ width: '100%' }}>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
          </div>
        </div>
      )}
    </div>
  );
};

